<div class="carfax-history-dialog">
  <div class="carfax-history-dialog-header flex-between-center">
    <div class="m-0 font-bold flex-start-center"
      [pTooltip]="isSync? '': 'Carfax and MOTOR returned different vehicles. You are viewing the history of the vehicle returned by Carfax.'"
      [ngClass]="{'font-red': this.hasConflicts}">
      <i class="fal fa-history font-20 font-gray-55 pr-2"></i>
      <p class="m-0">{{this.carfaxVehicleName}}</p>
    </div>

    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="carfax-history-dialog-body">
    <div class="carfax-history-header flex-between-center width-100p">
      <div class="flex-start-center tab-wrapper">
        <p class="flex-center-center m-0 tab pointer" [ngClass]="{'active': selectedTab === 0}"
          (click)="handleTabChange(0)">History</p>
        <p class="flex-center-center m-0 tab pointer" [ngClass]="{'active': selectedTab === 1}"
          (click)="handleTabChange(1)">Recalls</p>
      </div>

      <div class="flex-end-center"></div>
    </div>


    <div class="history-table flex-column width-100p">
      <div class="history-table-header flex-start-center">
        <p class="m-0 date pointer flex-between-center" (click)="handleSort('datetime')">
          <span>Date</span>
          <i class="fas" *ngIf="sortField === 'datetime'"
            [ngClass]="{'fa-sort-up': sortOrder, 'fa-sort-down': !sortOrder}"></i>
        </p>
        <p class="m-0 mileage pointer flex-between-center" (click)="handleSort('odometer')">
          <span>Mileage</span>
          <i class="fas" *ngIf="sortField === 'odometer'"
            [ngClass]="{'fa-sort-up': sortOrder, 'fa-sort-down': !sortOrder}"></i>
        </p>
        <p class="m-0 services pointer flex-between-center" (click)="handleSort('description')">
          <span>Services</span>
          <i class="fas" *ngIf="sortField === 'description'"
            [ngClass]="{'fa-sort-up': sortOrder, 'fa-sort-down': !sortOrder}"></i>
        </p>
      </div>

      <div class=" history-table-body flex-column">
        <div class="history-table-row flex-start-start"
          *ngFor="let item of selectedTab === 0? serviceHistory : serviceRecalls">
          <p class="m-0 date">{{item?.date}}</p>
          <p class="m-0 mileage">{{item?.odometer? item?.odometer + ' ' + odometerUnit: ''}}</p>
          <p class="m-0 services">{{item?.description}}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="carfax-history-dialog-footer flex-between-center">
    <p class="m-0 font-red" [ngClass]="{'invisible': !this.hasConflicts}">
      *Carfax returned a different vehicle than the one in system. System vehicle is <span
        class="font-600">{{internalVehicleName}}</span>
    </p>

    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">Close</button>
  </div>
</div>
